import { useQuery, UseQueryOptions, QueryKey } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { ZodSchema } from "zod";

interface UseFetchParams<TData, TQueryKey extends QueryKey> {
  queryKey: TQueryKey;
  url: string;
  schema: ZodSchema<TData>;
  enabled?: boolean;
  baseURL?: string;
}

export function useFetch<TData, TError = Error, TQueryKey extends QueryKey = QueryKey>(
  { queryKey, url, schema, enabled = true, baseURL }: UseFetchParams<TData, TQueryKey>,
  queryOptions?: Omit<
    UseQueryOptions<TData, TError, TData, TQueryKey>,
    "queryKey" | "queryFn" | "enabled"
  >,
) {
  return useQuery<TData, TError, TData, TQueryKey>({
    queryKey,
    enabled,
    queryFn: async ({ signal }) => {
      const response = await axiosInstance.get(url, {
        baseURL,
        signal,
      });

      return schema.parse(response.data);
    },
    ...queryOptions,
  });
}

